import ym from 'react-yandex-metrika'

import { data } from './NewBanner'
import { BannerAnalyticsHandler } from './NewBanner.types'

export const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0,
}

export const getPageType = (pageType: string, id: string | undefined) => {
  let page = ''

  switch (pageType) {
    case 'main':
      page = 'Главная'
      break

    case 'collection':
      page = `Подборка ${id}`
      break

    case 'article':
      page = `Статья ${id}`
      break

    default:
      page = 'Не определено'
  }

  return page
}

export const handleCarouselClick: BannerAnalyticsHandler = (
  name,
  id,
  pageType,
  place = 'bottom'
) => {
  const page = getPageType(pageType, id)
  ym('reachGoal', 'client link', {
    'client link': {
      'banner click': {
        [page]: `type ${place} - ${name}`,
      },
    },
  })
}

export const observAnalaytics: BannerAnalyticsHandler = (
  name,
  id,
  pageType,
  place = 'bottom'
) => {
  const page = getPageType(pageType, id)

  ym('reachGoal', 'banner show', {
    'banner show': {
      [page]: `type ${place} - ${name}`,
    },
  })
}

function setNumberToLocalStorage(number: number) {
  localStorage.setItem('bannerIndex', number.toString())
}

export function incrementNumber(array: any[]) {
  let currentNumber = localStorage.getItem('bannerIndex')

  if (currentNumber === null) {
    currentNumber = '0'
  }

  setNumberToLocalStorage((+currentNumber + 1) % array.length)
}
